import React, { useState, useEffect } from 'react';
import { getSocietes } from '../../flux/actions/societeActions';
import { getUsers } from '../../flux/actions/userActions';
import GoalCardContainer from './GoalCardContainer';
import { Container, Row, Col, Label, Input, Button, CustomInput, FormGroup, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalHeader, ModalBody, Collapse, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import { connect } from 'react-redux';
import { IGoalChargeContainer, IGoalChargeReduxProps, ICommission_history, ITarget } from '../../types/interfaces';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { PRIVILEGE } from '../../types/privileges'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faHouseUser, faUserTag, faAngleDoubleDown, faMoneyCheckAlt, faWallet, faBullseye, faExclamationCircle, faCalculator, faEdit, faCircle, faCheck, faTimes, faSearch, faCheckCircle, faSpinner, faPen, faCheckSquare, faAngleDown, faAngleUp, faList, faFolderPlus, faUser, faCaretLeft, faCaretRight, faCommentDots, faCalendarAlt, faTrash, faThumbtack, faCheckDouble, faListUl } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import Durations from '../Durations';
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants';
import { useParams } from "react-router-dom";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import moment from 'moment';
import DatePicker from "reactstrap-date-picker";
// ChartJS.register(ArcElement, Tooltip, Legend);
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import MonthPicker from 'react-month-picker'
import { betterTypeName } from '../../services/formatting';
import { instantPrint } from '../pdf/PDFLink';
import { useBeforeunload } from 'react-beforeunload'

const GoalChargeContainerComponent = ({
  getSocietes,
  getUsers,
  societe,
  user,
  auth
 }: IGoalChargeContainer) => {
  let { project: projectIdTarget, user: userIdTarget } = useParams();
  const alert = useAlert();

  const { users, loading: loadingU } = user;
  const { societes, loading: loadingS } = societe;
  const societeOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  const [societeValue, setSocieteValue] = useState<any>();
  const [filterUsers, setFilterUsers] = useState(true);
  const userOptions = (auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? [{id: "ALL", LOGIN: "Tous les commerciaux"}, ...users.map(e => ({id: e.id, LOGIN: e.username, worksatProjects: e.worksatProjects}))] : [{id: auth?.user?.id, LOGIN: auth?.user?.username, worksatProjects: auth?.user?.worksatProjects || []}]).filter(e => !(filterUsers && !!auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS)) || e.id === "ALL" || (e["worksatProjects"] && societeValue && (societeValue.id === "ALL" ? e["worksatProjects"].length : e["worksatProjects"].find(e => e.id === societeValue.id)))).map(e => ({value: e.id, label: e["LOGIN"] || e["username"], user: e}));
  const [selectedUser, setSelectedUser] = useState<any>(/*userOptions.find(e => e.value === "ALL")?.user || */'');
  const today = new Date();
  const [monthPickerValue, setMonthPickerValue] = useState({ year: today.getFullYear(), month: today.getMonth() + 1 });
  const monthPickerRef = React.useRef<any>(null);

  // useEffect(() => {
  //   if(auth?.user?.societes?.length)
  //     for(let e of auth.user.societes)
  //       if(e.id == auth.user.last_societe){
  //         setSocieteValue(e);
  //         break
  //       }
  // }, [auth?.user?.societes]);

  useEffect(() => {
    if(!societeValue && societes?.length){
      let choosenId: any = undefined;
      if(projectIdTarget !== undefined)
        choosenId = projectIdTarget
      else if(auth && auth.user)
        choosenId = auth.user.last_societe
      if(choosenId !== undefined){
        for(let so of societes)
          if(so.id == choosenId){
            setSocieteValue(so);
            break
          }
      }
    }
  }, [societes]);

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  useEffect(() => {
    if(selectedUser === ''){
      let choosenId: any = undefined;
      if(userIdTarget !== undefined)
        choosenId = userIdTarget
      else if(auth?.user?.id !== undefined)
        choosenId = auth.user.id
      if(choosenId !== undefined)
        setSelectedUser((choosenId == -1 ? (/*auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? userOptions.find(e => e.value === "ALL")?.user : */undefined) : userOptions.find(e => e.user.id == choosenId)?.user) || '')
    }
  }, [auth?.user, userOptions]);
  
  const showMonthPicker = () => {
    if(monthPickerRef?.current)
      monthPickerRef.current.show()
  };

  const handlePickerChange = (year, month) => {
    setMonthPickerValue({ year, month });
    if(monthPickerRef?.current)
      monthPickerRef.current.dismiss()
  };
  
  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }
  const handleUserChange = data => {
    setSelectedUser(data ? data.user : '');
  }

  const filterUsersChangeHandler = e => {
    setFilterUsers(e.target.checked);
  };
  
  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }

  useEffect(() => {
    if(selectedUser && !userOptions.find(e => e.user?.id === selectedUser.id))
      setSelectedUser('')
  }, [userOptions])

  return !auth?.user ? <LoadingPage/> : (
    <>
      <Container>
        <Row>
          <Col xs="12" lg="6"><h4 className="title"><FontAwesomeIcon icon={faCalculator} />&nbsp;&nbsp;Objectif Commercial</h4></Col>
          <Col xs="12" md="6" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="societe">Projet : </Label>
            </div>
            <Select
              name="reactselect"
              className="reactselect"
              classNamePrefix="react-select"
              id="societe"
              value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
              onChange={handleSocieteChange}
              placeholder={'Chercher par projet...'}
              isClearable={false}
              isLoading={loadingS}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              labelKey='LIBELE'
              // valueKey='code'
              options={societeOptions}
              filterOption={filterOptions}
            />
          </Col>
          <Col xs="12" md="6" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="user">Commercial : </Label>
            </div>
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={selectedUser ? {label: selectedUser["LOGIN"] || selectedUser["username"], value: selectedUser.id, user: selectedUser} : null}
              onChange={handleUserChange}
              placeholder={'Chercher par nom...'}
              isClearable={false}
              isLoading={loadingU}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
        </Row>
        {!!auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) && <Row className="justify-content-end" style={{marginBottom: "5px"}}>
          <FormGroup check>
            <Input type="checkbox" id="filterUsers" checked={filterUsers} onChange={filterUsersChangeHandler} />
            <Label for="filterUsers" check>Filtrer les commerciaux</Label>
          </FormGroup>
        </Row>}
      </Container>
      <Container>
        <Row>
          <Col xs="12" className="text-center">
            <h3 className="fullFlexCenter" style={{letterSpacing: "8px", fontFamily: "'Ultra', sans-serif", color: "darkslategray"}}>
              <MonthPicker
                ref={monthPickerRef}
                // years={[2008, 2011, 2012, 2014, 2016, 2018, 2020]}
                years={{min: 2010, max: 2069}}
                value={monthPickerValue}
                key={JSON.stringify(monthPickerValue)}
                lang={constants.MONTHS_ABBRV}
                onChange={handlePickerChange} >
                <div style={{cursor: "pointer"}} onClick={showMonthPicker} title="Changer la date">{constants.DP_MONTHS[monthPickerValue.month - 1]}&nbsp;{monthPickerValue.year}&nbsp;<FontAwesomeIcon icon={faCalendarAlt} /></div>
              </MonthPicker>
            </h3>
          </Col>
        </Row>
        <GoalCardContainer selectedUser={selectedUser} societeValue={societeValue} monthPickerValue={monthPickerValue} users={users.filter(e => !(filterUsers && !!auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS)) || (e["worksatProjects"] && societeValue && (societeValue.id === "ALL" ? e["worksatProjects"].length : e["worksatProjects"].find(e => e.id === societeValue.id))))} loadingU={loadingU} />
      </Container>
    </>
  );
};

const mapStateToProps = (state: IGoalChargeReduxProps) => ({
  societe: state.societe,
  user: state.user,
  auth: state.auth
});

export default connect(mapStateToProps, { getSocietes, getUsers })(GoalChargeContainerComponent);
